import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type IInviteUserRepository } from 'application/repositorySchemas/IInviteUserRepository';
import { type IInviteUserClient } from 'interfaceAdapter/gatewaySchemas/IInviteUserClient';

@injectable()
export class InviteUserRepository implements IInviteUserRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IInviteUserClient')
        public readonly inviteUserClient: IInviteUserClient,
    ) {}

    public async post(email: string, invitation_type: 'seller' | 'buyer') {
        const { data, message } = await this.inviteUserClient.post({
            token: this.supportUserToken.get() || '',
            email,
            invitation_type,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
